import { observer } from "mobx-react-lite";
import { Spin, SpinProps } from "antd";
import { useEffect, useRef, useState } from "react";
import ScrollToTop from "./ScrollToTop";

const PageBox = observer((props: SpinProps & { children?: any }) => {

  // overflow-y: scroll;           /* 允许垂直滚动 */
  // scrollbar-width: none;        /* Firefox 隐藏滚动条 */
  // -ms-overflow-style: none;   
  return (
    <Spin    {...props} >
      <ScrollToTop />
      {props.children ?? <div />}
    </Spin>
  );
});
export default PageBox;
